import React from 'react';
import { FadeIn } from './FadeIn';
export function PremiumUpsell() {
  return <section className="py-20 sm:py-32 px-4 bg-carbon-900 border-t border-carbon-800 relative overflow-hidden" data-id="element-118">
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-amber-500/5 rounded-full blur-[120px] pointer-events-none" data-id="element-119" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-120">
        <FadeIn data-id="element-121">
          <div className="flex items-center gap-4 mb-12" data-id="element-122">
            <span className="font-display text-4xl text-amber-500/20" data-id="element-123">06</span>
            <div className="h-px bg-amber-500/20 flex-grow" data-id="element-124" />
            <span className="font-mono text-xs text-amber-500 uppercase tracking-widest" data-id="element-125">
              Nivel Avanzado
            </span>
          </div>

          <h2 className="text-4xl sm:text-6xl font-display text-white mb-12 uppercase tracking-wide leading-[1.1]" data-id="element-126">
            Existe una versión del método que incluye los{' '}
            <br className="hidden sm:block" data-id="element-127" />
            <span className="text-amber-500" data-id="element-128">
              Protocolos Elite de Rendimiento.
            </span>
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-129">
          <div className="border border-amber-500/30 bg-carbon-950 rounded-[2.5rem] p-8 sm:p-12 relative overflow-hidden" data-id="element-130">
            <div className="absolute top-0 left-0 w-1 h-full bg-amber-500" data-id="element-131" />

            <div className="prose prose-invert prose-lg max-w-none font-sans text-carbon-300 mb-10" data-id="element-132">
              <p data-id="element-133">
                Y esa versión resuelve algo que los 6 tomos base no resuelven
                solos:{' '}
                <strong className="text-white font-semibold" data-id="element-134">
                  la brecha entre entrenar bien y entrenar a nivel elite con
                  precisión táctica.
                </strong>
              </p>
              <p data-id="element-135">
                Porque podés seguir el método completo y tener excelentes
                resultados. Pero si querés escalar a un nivel más serio,
                necesitás herramientas más específicas: periodización avanzada,
                protocolos de peak performance y estrategias de ajuste fino que
                no están en el sistema base.
              </p>
            </div>

            <h3 className="text-2xl font-display text-white mb-6 uppercase tracking-wide" data-id="element-136">
              Los Protocolos Elite cierran esa brecha.
            </h3>

            <ul className="space-y-4 mb-10 font-sans text-carbon-300" data-id="element-137">
              {['Periodización avanzada para atletas con más de 2 años de entrenamiento.', 'Bloques de rendimiento específico con dobles sesiones bien estructuradas.', 'Estrategias de deload avanzado y ajuste fino de fatiga.', 'Protocolos de peak performance para eventos o retos específicos.', 'Calendario de progresión de 12-16 semanas para nivel avanzado.'].map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-138">
                  <span className="font-mono text-amber-500 text-sm mt-1" data-id="element-139">
                    →
                  </span>
                  <span data-id="element-140">{item}</span>
                </li>)}
            </ul>

            <div className="bg-amber-500/10 border border-amber-500/20 p-4 text-center" data-id="element-141">
              <p className="text-amber-500 font-mono text-xs uppercase tracking-widest" data-id="element-142">
                No es para todos. Es para el atleta que quiere que el método
                base sea el punto de partida, no el techo.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}